var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotifInfo = function SvgNotifInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.548 12.698c.392 0 .755-.03 1.112.006.76.078 1.356.843 1.34 1.677-.017.87-.614 1.599-1.39 1.648-.55.034-1.103.022-1.655.023-1.098.003-2.195-.001-3.292.002-.67.002-1.189-.283-1.503-.951-.47-1.003.148-2.283 1.172-2.398.363-.04.733-.006 1.116-.006V3.37c-.288 0-.572.018-.854-.003C.885 3.313.3 2.7.204 1.93.107 1.164.499.4 1.155.134c.206-.084.438-.12.658-.125C2.508-.006 3.203.001 3.9.004c.995.005 1.648.723 1.648 1.821.002 3.51.001 7.018.001 10.527v.346z",
    mask: "url([name='k7370qwkfb'])",
    transform: "translate(0 5.946)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.285 0c1.12 0 1.998.905 2 2.062.003 1.158-.895 2.1-2 2.1-1.095 0-1.993-.934-2-2.078C2.28.913 3.156.001 4.286 0"
  }))));
};
export default SvgNotifInfo;